import React from "react";
import { RisksId } from "../../../../helpers/risk";
import Checkbox from "@material-ui/core/Checkbox";
import TooltipInfo from "../../../sharedComponents/tooltipInfo/tooltipInfo";
import "./riskName.scss";
import { FormControlLabel } from "@material-ui/core";
import { AdditionalInsurancesName, SimpleAdditionalInsuranceModel } from "../../../../helpers/additionalInsurances";
import Notification from "../../../sharedComponents/notification/notification";
import { inject, observer } from "mobx-react";
import { CalculateStore } from "../../../../stores/calculateStore";
import { RisksNetworkTypes } from "../../../../helpers/risksNetwork";
import CheckIcon from "@material-ui/icons/Check";

interface RiskNameProps {
  checkboxOnChange: (event: any) => void;
  riskId: RisksId;
  available?: boolean;
  required?: boolean;
  displayIcon: boolean;
  infoMessage?: string;
  calculateStore?: CalculateStore;
}

export const RiskName: React.FunctionComponent<RiskNameProps> = props => {
  const additionalInsurances = AdditionalInsurancesName;
  if (!additionalInsurances.hasOwnProperty(props.riskId)) {
    return null;
  }

  // @ts-ignore
  const riskConfiguration = additionalInsurances[props.riskId];
  // @ts-ignore
  const risk = props.calculateStore!.additionalInsurances[props.riskId] as SimpleAdditionalInsuranceModel;
  const required = risk.risksNetworkValue === RisksNetworkTypes.required || props.required;
  const notAvailable = risk.risksNetworkValue === RisksNetworkTypes.notAvailable || props.available === false;

  return (
    <div className="risk-name-wrapper">
      <div className="risk-name">
        <div className="risk-name-content">
          {renderRisk()}
          {riskConfiguration.contextHelp && !notAvailable && (
            <div className="tooltip">
              <TooltipInfo infoMessage={riskConfiguration.contextHelp} />
            </div>
          )}
          {props.infoMessage && <Notification type="info" message={props.infoMessage} />}
        </div>

        {props.children}
      </div>
    </div>
  );

  function renderRisk() {
    if (required) {
      return renderRequiredRisk();
    } else if (notAvailable) {
      return renderNotAvailableRisk();
    }

    return renderAvailableRisk();
  }

  function renderAvailableRisk() {
    return (
      <FormControlLabel
        control={
          <Checkbox checked={risk.checked}
            onChange={(event) => {
              props.checkboxOnChange(event);
            }}
          />
        }
        label={
          renderLabel()
        }
      />
    );
  }

  function renderRequiredRisk() {
    return (
      <span className="icon-and-label">
        <CheckIcon className="union" color="primary" />
        {renderLabel()}
      </span>
    );
  }

  function renderNotAvailableRisk() {
    return (
      <span className="icon-and-label disabled">
        {renderLabel()}
      </span>
    );
  }

  function renderLabel() {
    return (
      <>
        {props.displayIcon &&
          <div className={`icon ${notAvailable ? "disabled" : ""}`}>{riskConfiguration.icon}</div>}
        <div
          className={`display-name ${notAvailable ? "disabled" : ""}`}>{riskConfiguration.displayName}</div>
      </>
    );
  }
};
export default inject("calculateStore")(observer(RiskName));
